import React, { useState } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import Header_Btn from "../common/header-btn/Header_Btn";
import Login_Modal from "../modals/login-modal/Login_Modal";
import Common_Btn from "../common/common-btn/Common_Btn";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showLoginBtn, setShowLoginBtn] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const token = Cookies.get("excellent_website_security");
  const isAuthenticated = Boolean(token);

  const getprofile = useSelector((state) => state?.profile?.getprofile);

  // ✅ Check test page route
  const isTestPage = location.pathname.startsWith("/test-page/");

  // ✅ Hide header completely
  if (isTestPage) return null;

  return (
    <>
      <section className="main_head">
        <div className="container-md">
          <Navbar
            expand="lg"
            className="main_navbar p-0"
            onToggle={(value) => setExpanded(value)}
            expanded={expanded}
          >
            <Navbar.Brand>
              <div
                className="logodiv"
                onClick={() => {
                  setExpanded(false);
                  navigate("/");
                }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/images/header/logo.png"
                  }
                  alt="Logo"
                  className="logo_img"
                />
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto nav_links">
                <Nav.Link
                  as={Link}
                  to={"/"}
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/career-counselling"}
                  onClick={() => setExpanded(false)}
                  className={
                    location.pathname === "/career-counselling" ? "active" : ""
                  }
                >
                  Career Counselling
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/parental-counselling"}
                  onClick={() => setExpanded(false)}
                  className={
                    location.pathname === "/parental-counselling"
                      ? "active"
                      : ""
                  }
                >
                  Parental Counselling
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/about-us"}
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/about-us" ? "active" : ""}
                >
                  About Us
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/contact-us"}
                  onClick={() => setExpanded(false)}
                  className={
                    location.pathname === "/contact-us" ? "active" : ""
                  }
                >
                  Contact Us
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to={"/blogs"}
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/blogs" ? "active" : ""}
                >
                  Blogs
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/test-instructions"}
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/test" ? "active" : ""}
                >
                  Test
                </Nav.Link>
              </Nav>

              <div className="header_btn">
                {/* HEADER BUTTON CHANGE */}
                {/* {isLoggedIn ? (
                  <Header_Btn
                    text={getprofile?.user?.first_name}
                    link="/profile"
                    onClick={() => setExpanded(false)}
                  />
                ) : (
                  <Common_Btn
                    text="Login"
                    onClick={() => {
                      setShowModal(true);
                      setExpanded(false);
                    }}
                  />
                )} */}
                {isAuthenticated ? (
                  <Header_Btn
                    text="Profile"
                    link="/profile"
                    onClick={() => setExpanded(false)}
                  />
                ) : (
                  <Common_Btn
                    text="Login"
                    onClick={() => {
                      setShowModal(true);
                      setExpanded(false);
                    }}
                  />
                )}
              </div>
            </Navbar.Collapse>
          </Navbar>
        </div>

        <Login_Modal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleLogin={() => setIsLoggedIn(true)}
        />
      </section>
    </>
  );
}

export default Header;
